<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs
			:breadcrumbs="page.breadcrumbs"
			:class="page.headingImage ? '' : 'no-slider'"
			:home="defaults[locale].website.hotelName"
		/>

		<main-content :title="page.title || page.header" :content="page.content" :booking-id="page.bookingID" />

		<section class="main-content background-color">
			<div v-if="defaults[locale].hotelInformation.header" class="row">
				<div class="columns column12 align-center">
					<h2>{{ defaults[locale].hotelInformation.header }}</h2>
					<br /><br />
				</div>
			</div>
			<div class="row items flex-row">
				<div
					v-for="item in defaults[locale].hotelInformation.info"
					:key="item.ID"
					class="columns column3 icon-div"
				>
					<font-awesome-icon v-if="item.icon == 'chromecast'" :icon="'fa-brands fa-' + item.icon" size="1x" />
					<font-awesome-icon v-else :icon="'fa-light fa-' + item.icon" size="1x" />
					<div v-parse-links v-html="item.content" />
				</div>
			</div>
		</section>

		<contentblocks v-if="page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].website.newsletterHeader"
			:content="defaults[locale].website.newsletterContent"
			:button="defaults[locale].website.newsletterButton"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();
</script>

<style lang="scss" scoped>
.icon-div {
	display: flex;
	flex-flow: column wrap;
	justify-content: flex-start;
	align-items: center;
	margin: 0 0 60px;

	svg {
		font-size: 50px;
		margin: 0 auto 25px;
		color: #000;
	}

	.button,
	:deep(.button) {
		margin: 3px 0;
		width: 100%;
	}

	p,
	:deep(p) {
		text-align: center;
	}
}
</style>
